import { removeMaskCpf } from '../cpf'
import { ParseCreateUserProps } from './types/typeRequestParse'

function parseCreateUser(request: ParseCreateUserProps) {
  request.phone.type = parseInt(request.phone.type)
  request.cpf = removeMaskCpf(request.cpf)

  return request
}

export default parseCreateUser
